module.exports = "/images/register_bg.jpg?2691ff795ad7bb084bb7c580a90e1618";